import React from "react";
import cc from "classcat";

const ChevronLeftButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <div
      className="narmi-icon-chevron-left clickable"
      onClick={onClick}
      onKeyUp={({ key }) => {
        if (key === "Enter") onClick();
      }}
      aria-label="Go back"
      role="button"
      tabIndex={0}
    />
  );
};

const FormHeaderWithIcon = ({
  headerText,
  subheader,
  iconComponent,
  onBack,
}: {
  headerText: string;
  subheader?: React.ReactNode;
  iconComponent?: React.ReactNode;
  onBack?: () => void;
}) => {
  return (
    <div className="form-header-with-icon">
      <div
        className={cc([
          "main-header-container",
          "alignChild--left--center",
          { "title-with-chevron": onBack },
        ])}
      >
        {onBack && <ChevronLeftButton onClick={onBack} />}
        <h1>{headerText}</h1>
        {iconComponent}
      </div>
      {subheader && <div className="subheader-text">{subheader}</div>}
    </div>
  );
};

export default FormHeaderWithIcon;
